export const BOTTOM_MESSAGE = {
  ACTION_TYPES: {
    bottomMessageClick: 'bottomMessageClick'
  }
}
